import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "common/services/api";
import { constant } from "common/constant";

// Get userId from localStorage
const userId = JSON.parse(localStorage.getItem("user"))?._id;

// Async thunk to fetch user view
export const fetchUserView = createAsyncThunk(
  "userView/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getApi(`api/user/view/${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || constant.failedToLoadUser);
    }
  }
);

const userViewSlice = createSlice({
  name: "userView",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserView.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserView.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserView.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userViewSlice.reducer;
